module.exports = __webpack_public_path__ + "hook.jpg?014afe47d9f3c0ce912938697cc501c3";